var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "nav-section" }, [
      _c(
        "a",
        {
          staticClass: "nav-back",
          attrs: { id: "settings-engineers-hkl-user-detail-back" },
          on: {
            click: function ($event) {
              return _vm.$router.go(-1)
            },
          },
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("back")) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "user-detail-wrapper" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "small-6 medium-6 large-6 columns" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("user.fullName")) + ":"),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "label-content" }, [
            _vm._v(_vm._s(_vm.userName(_vm.pendingUpdateUser))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "small-6 medium-6 large-6 columns user-detail-header-right",
          },
          [
            _c("div", { staticClass: "user-detail-header-top" }, [
              _c("div", { staticClass: "last-login-info" }, [
                _c("label", { staticClass: "emphasis" }, [
                  _vm._v(_vm._s(_vm.$t("lastLogin")) + ":"),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "label-content" }, [
                  _vm._v(
                    _vm._s(_vm._f("isEmptyValue")(_vm.formattedLastLoginAt))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "controls right-adjusted header-controls" },
                [
                  _vm.aclHelper.getSettingsUpdateAccess() && !_vm.allowEdit
                    ? _c("HKLButton", {
                        attrs: { color: "orange", action: "notify" },
                        on: {
                          click: function () {
                            return _vm.notify()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aclHelper.getSettingsUpdateAccess() && !_vm.allowEdit
                    ? _c("HKLButton", {
                        attrs: { color: "orange", action: "edit" },
                        on: {
                          click: function ($event) {
                            return _vm.enableEdit()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aclHelper.getSettingsUpdateAccess() && _vm.allowEdit
                    ? _c("HKLButton", {
                        attrs: { color: "darkblue", action: "cancel" },
                        on: {
                          click: function ($event) {
                            return _vm.discardChange()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aclHelper.getSettingsUpdateAccess() && _vm.allowEdit
                    ? _c("HKLButton", {
                        attrs: { action: "save", color: "orange" },
                        on: {
                          click: function ($event) {
                            return _vm.save()
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "small-6 medium-6 large-6 columns" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("username")) + ":"),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "label-content username-content" }, [
            _vm._v(_vm._s(_vm.pendingUpdateUser.username)),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("position")) + ":"),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "label-content position-content" }, [
            _vm._v(_vm._s(_vm.pendingUpdateUser.title || "N/A")),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("userType.name")) + ":"),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "label-content" }, [
            _vm._v(_vm._s(_vm.$t(_vm.userType))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "small-6 medium-6 large-6 columns" }, [
          _c(
            "div",
            {
              staticClass: "large-8 medium-8 small-8 columns",
              attrs: { id: "settings-engineers-hkl-user-detail-status" },
            },
            [
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(_vm._s(_vm.$t("status.name")) + ":"),
              ]),
              _vm._v(" "),
              _c("HKLSelect", {
                attrs: {
                  disabled:
                    !_vm.allowEdit ||
                    _vm.currentUser.id === _vm.$router.currentRoute.params.id,
                  options: _vm.userStatusHklOptions,
                  showSearch: false,
                  placeholder: "",
                  value: _vm.userStatusMapping[_vm.pendingUpdateUser.enabled],
                },
                on: { change: _vm.updateStatus },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("user.phone")) + ":"),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "label-content" }, [
            _vm._v(_vm._s(_vm.primaryContactPhoneNumber || "N/A")),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("user.email")) + ":"),
          ]),
          _vm._v(" "),
          !_vm.allowEdit
            ? _c("label", { staticClass: "label-content" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.primaryContactEmail) +
                    "\n        "
                ),
              ])
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.primaryContactEmail,
                    expression: "primaryContactEmail",
                  },
                  { name: "hkldinput", rawName: "v-hkldinput" },
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: {
                      type: "string",
                      pattern: _vm.regex.email,
                      classes: "tooltip-class",
                      tip: _vm.$t("hint.inputTip.email"),
                    },
                    expression:
                      "{\n            type: 'string',\n            pattern: regex.email,\n            classes: 'tooltip-class',\n            tip: $t('hint.inputTip.email')}",
                  },
                ],
                staticClass: "label-content detail-input",
                attrs: { id: "user-detail-email-input", type: "email" },
                domProps: { value: _vm.primaryContactEmail },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.primaryContactEmail = $event.target.value
                  },
                },
              }),
        ]),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "hr-style" }),
      _vm._v(" "),
      _c("div", [
        _c("label", { staticClass: "emphasis" }, [
          _vm._v(_vm._s(_vm.$t("settings.dashboard.title")) + ":"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "profile-dashboard-radios" },
          _vm._l(_vm.defaultDashboardOptions, function (item) {
            return _c("label", { key: item.key }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.pendingUpdateUser.dashboard,
                    expression: "pendingUpdateUser.dashboard",
                  },
                  { name: "hkldinput", rawName: "v-hkldinput" },
                ],
                attrs: {
                  id: [
                    "modules-settings-engineers-hkl-user-radio-" +
                      item.code +
                      "-dashboard",
                  ],
                  type: "radio",
                  disabled: !_vm.allowEdit,
                },
                domProps: {
                  value: item.code,
                  checked: _vm._q(_vm.pendingUpdateUser.dashboard, item.code),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.pendingUpdateUser,
                      "dashboard",
                      item.code
                    )
                  },
                },
              }),
              _vm._v("\n          " + _vm._s(item.fullName) + "\n        "),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "hr-style" }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "small-6 medium-6 large-6 columns" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("settings.group")) + ":"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "label-content user-roles" }, [
            _vm._v("\n          " + _vm._s(_vm.userRoles) + "\n        "),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "ul",
              { class: { "ul--disable": !_vm.allowEdit } },
              _vm._l(_vm.roles, function (role, index) {
                return _c("li", { key: index }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: role.checked,
                        expression: "role.checked",
                      },
                      { name: "hkldinput", rawName: "v-hkldinput" },
                    ],
                    attrs: {
                      id:
                        "modules-settings-engineers-hkl-user-checkbox-" + index,
                      type: "checkbox",
                      disabled: role.disabled,
                    },
                    domProps: {
                      checked: Array.isArray(role.checked)
                        ? _vm._i(role.checked, null) > -1
                        : role.checked,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = role.checked,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(role, "checked", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                role,
                                "checked",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(role, "checked", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "items",
                      attrs: {
                        for:
                          "modules-settings-engineers-hkl-user-checkbox-" +
                          index,
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            role.name === _vm.AdminRoleName[0]
                              ? _vm.$i18n.t("settings.security.systemAdmin")
                              : role.name
                          ) +
                          "\n              "
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _vm.enableTenancyRecordsFeature
            ? _c("div", [
                _c("label", { staticClass: "emphasis" }, [
                  _vm._v(_vm._s(_vm.$t("settings.tenancyAccess")) + ":"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "label-content tenancy-access" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.tenancyAccess.join(", ")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("ul", { class: { "ul--disable": !_vm.allowEdit } }, [
                    _c("li", [
                      _c("input", {
                        directives: [
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        attrs: {
                          id: "modules-settings-engineers-tenancies-checkbox-0",
                          type: "checkbox",
                          disabled: !_vm.allowEdit,
                        },
                        domProps: {
                          checked: _vm.deep(_vm.access, "tenancies.Office"),
                        },
                        on: {
                          change: function (event) {
                            return _vm.updateAccess(
                              "Office",
                              event.target.checked
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "items",
                          attrs: {
                            for: "modules-settings-engineers-tenancies-checkbox-0",
                          },
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.translateTenancyType("Office")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        attrs: {
                          id: "modules-settings-engineers-tenancies-checkbox-1",
                          type: "checkbox",
                          disabled: !_vm.allowEdit,
                        },
                        domProps: {
                          checked: _vm.deep(_vm.access, "tenancies.Retail"),
                        },
                        on: {
                          change: function (event) {
                            return _vm.updateAccess(
                              "Retail",
                              event.target.checked
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "items",
                          attrs: {
                            for: "modules-settings-engineers-tenancies-checkbox-1",
                          },
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.translateTenancyType("Retail")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "small-5 medium-5 large-5 columns" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("settings.tab.departmentSiteBuilding")) + ":"),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "ul",
              { class: [{ "ul--disable": !_vm.allowEdit }, "dept-ul"] },
              _vm._l(_vm.allDeptLocBld, function (dept, index) {
                return _c("li", { key: index, staticClass: "dept-ul-li" }, [
                  _c("i", {
                    class: [
                      dept.isExpand ? "fa-angle-down" : "fa-angle-right",
                      "fa angle",
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.switchArrow(dept)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    attrs: {
                      id:
                        "modules-settings-engineers-hkl-user-checkbox-dept" +
                        index,
                      type: "checkbox",
                      disabled: true,
                    },
                    domProps: { checked: dept.checked },
                    on: {
                      change: function (event) {
                        return _vm.updateDepartment(event.target.checked, dept)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "items",
                      attrs: {
                        for:
                          "modules-settings-engineers-hkl-user-checkbox-dept" +
                          index,
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(dept.name) +
                          "\n              "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: dept.isExpand,
                          expression: "dept.isExpand",
                        },
                      ],
                      staticClass: "sites-ul",
                    },
                    [
                      _c("li", [
                        _c("input", {
                          directives: [
                            { name: "hkldinput", rawName: "v-hkldinput" },
                          ],
                          attrs: {
                            id:
                              "modules-settings-engineers-hkl-user-checkbox-dept-is-admin" +
                              index,
                            type: "checkbox",
                            disabled: !_vm.allowEdit,
                          },
                          domProps: { checked: dept.isAdmin },
                          on: {
                            change: function (event) {
                              return _vm.updateDepartmentAdmin(
                                event.target.checked,
                                dept
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "items",
                            attrs: {
                              for:
                                "modules-settings-engineers-hkl-user-checkbox-dept-is-admin" +
                                index,
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(dept.name + " Admin") +
                                "\n                  "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(dept.sites, function (site, s_index) {
                        return _c("li", { key: site.id + s_index }, [
                          _c("input", {
                            directives: [
                              { name: "hkldinput", rawName: "v-hkldinput" },
                            ],
                            attrs: {
                              id:
                                "modules-settings-engineers-hkl-user-checkbox-site-" +
                                site.id,
                              type: "checkbox",
                              disabled: !_vm.allowEdit,
                            },
                            domProps: { checked: site.checked },
                            on: {
                              change: function (event) {
                                return _vm.updateSite(
                                  event.target.checked,
                                  site,
                                  dept
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "items",
                              attrs: {
                                for:
                                  "modules-settings-engineers-hkl-user-checkbox-site-" +
                                  site.id,
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(site.code) +
                                  "\n                  "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "buildings-ul" },
                            _vm._l(
                              site.buildings,
                              function (building, b_index) {
                                return _c("li", { key: b_index }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                    ],
                                    attrs: {
                                      id:
                                        "modules-settings-engineers-hkl-user-" +
                                        site.code +
                                        "-bld-" +
                                        b_index,
                                      type: "checkbox",
                                      disabled: !_vm.allowEdit,
                                    },
                                    domProps: { checked: building.checked },
                                    on: {
                                      change: function (event) {
                                        return _vm.updateBuilding(
                                          event.target.checked,
                                          building,
                                          site,
                                          dept
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "items",
                                      attrs: {
                                        for:
                                          "modules-settings-engineers-hkl-user-" +
                                          site.code +
                                          "-bld-" +
                                          b_index,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(building.code) +
                                          "\n                      "
                                      ),
                                    ]
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }